var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSac(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 400 400",
    enableBackground: "new 0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 48.364,
    y: 26.5,
    width: 304.161,
    height: 347
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M352.524,26.5l-43.53,43.701l-36.38-36.334l-36.547,36.339l-36.319-36.339 l-36.306,36.334l-36.33-36.334L90.813,70.22l-42.45-42.849v193.501c0,84.155,67.514,152.628,151.62,152.628 c84.124,0,152.541-68.473,152.541-152.628V26.5z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5C6670",
    d: "M61.941,247.374c3.596,18.226,10.7,35.348,21.176,50.944 c6.325-11.093,18.98-24.873,43.834-30.728c-1.909-6.382-3.61-13.167-5.053-20.217H61.941z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5C6670",
    d: "M93.034,311.43c26.859,31.479,65.535,49.626,106.309,49.893 c-3.845-1.964-7.607-4.126-11.226-6.453c-17.284-11.172-41.046-32.914-56.389-73.221C107.58,286.912,97.358,300.601,93.034,311.43"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5C6670",
    d: "M146.606,279.533c10.89,27.377,27.343,48.414,48.938,62.535 c14.277,9.35,27.961,13.601,36.983,15.527c22.577-5.269,43.665-16.15,61.118-31.529c-13.771-1.508-27.891-9.433-42.796-17.791 c-23.272-13.063-52.254-29.318-91.382-29.318C155.242,278.957,150.925,279.161,146.606,279.533"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5B2B82",
    d: "M205.441,176.167h-50.316v59.905h20.903V188.02h15.703v48.053h19.921v-51.515 C211.651,179.994,208.862,176.167,205.441,176.167"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5B2B82",
    d: "M220.459,176.167v51.39c0,4.574,2.766,8.516,6.177,8.516h32.951h17.315v-36.371 l-20.069-0.023v24.526h-15.696v-36.476h35.766v-11.562H220.459z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5B2B82",
    points: "99.495,176.167 88.126,200.359 81.56,200.359 81.56,176.167  60.754,176.167 60.754,236.072 81.56,236.072 81.56,211.968 88.126,211.968 99.495,236.072 120.282,236.072 105.621,206.163  120.282,176.167  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.818,
    y: 176.167,
    clipPath: "url(#SVGID_2_)",
    fill: "#5B2B82",
    width: 21.54,
    height: 59.905
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5B2B82",
    d: "M340.191,192.368v-16.201h-55.228v27.368c0,4.563,2.771,8.27,6.175,8.27h28.14 v13.056h-34.314v11.212h55.255v-27.499c0-4.255-2.35-8.253-5.514-8.253h-29.013v-12.544h14.514v4.592H340.191z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5B2B82",
    points: "281.438,115.411 263.802,115.411 300.175,79.021 272.614,51.508  236.067,87.841 199.748,51.508 135.895,115.411 118.26,115.411 154.571,78.966 127.112,51.508 90.813,87.841 60.755,58.003  60.755,117.624 60.755,165.174 340.187,165.174 340.187,119.058 340.187,56.62  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M121.798,153.659c0,1.555,1.268,2.824,2.812,2.824h15.703v-4.219h-12.798 v-13.684h12.798v-4.209h-18.515V153.659z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M96.198,134.37v22.112h5.712v-5.785h7.085v5.785h5.717v-19.294 c0-1.655-1.329-2.818-3.14-2.818H96.198z M108.996,146.491h-7.086v-7.907h7.086V146.491z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M327.004,134.37h-12.955c-1.54,0-2.803,1.255-2.803,2.799v16.491 c0,1.544,1.263,2.821,2.803,2.821h12.955c1.544,0,2.803-1.286,2.803-2.83v-16.482C329.807,135.625,328.548,134.37,327.004,134.37  M324.067,152.231h-7.061v-13.656h7.061V152.231z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M70.577,144.716c0,1.549,1.268,2.813,2.816,2.813h9.981v4.733H70.577v4.219 h18.515v-10.354c0-1.438-1.074-2.642-2.514-2.794l-0.156-0.014H76.284v-4.74h12.808v-4.209H70.577V144.716z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M188.229,134.37h-15.693v22.112h5.717v-5.785h7.086v5.785h5.721v-19.294 C191.059,135.639,189.787,134.37,188.229,134.37 M185.338,146.491h-7.086v-7.907h7.086V146.491z"
  }), /*#__PURE__*/React.createElement("polygon", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    points: "286.339,138.574 292.75,138.574 292.75,156.481 298.454,156.481  298.454,138.574 304.857,138.574 304.857,134.37 286.339,134.37  "
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M227.07,134.37h-28.427v22.113h5.716v-17.901h7.009v17.901h5.793v-17.901h7.004 v17.901h5.718v-19.299C229.883,135.64,228.614,134.37,227.07,134.37"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M277.73,134.37h-15.695v22.113h5.713v-17.901h7.086v17.901h5.717v-19.299 C280.551,135.64,279.284,134.37,277.73,134.37"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M237.666,153.659c0,1.555,1.259,2.824,2.813,2.824h15.688v-4.219h-12.784v-4.74 h12.784v-4.2h-12.784v-4.744h12.784v-4.209h-18.501V153.659z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#FFFFFF",
    d: "M162.351,148.437h3.057v-11.254c0-1.65-1.357-2.813-3.14-2.813h-15.376v22.112 h5.712v-8.044h4.145l3.421,8.044h5.568L162.351,148.437z M159.69,144.232h-7.085v-5.652h7.085V144.232z"
  }), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "#5C6670",
    d: "M156.417,264.338c29.771-0.605,59.212,6.849,96.78,28.257 c27.768,15.822,39.968,20.621,48.294,18.572c7.672-1.887,14.788-6.419,27.344-32.956c4.792-10.129,8.234-22.135,9.907-30.83 H136.771c1.406,6.118,2.787,12.203,4.634,17.801C146.294,264.634,151.35,264.338,156.417,264.338"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSac);
export default __webpack_public_path__ + "static/media/SAC.660573bab48fc7487e3a7b0faa9175fb.svg";
export { ForwardRef as ReactComponent };